import { useLocation } from "react-router-dom";
import { getSelectedContext, getStaffToken } from "@/lib/api";
import { useOutletFeatures } from "@/hooks/useOutletFeatures";

/**
 * Mounted once inside the router for the whole app. While an outlet staff
 * session is selected it keeps that outlet's feature switches (CRM on/off)
 * current; guest pages and Brand HQ fetch nothing. Reading the location
 * re-checks the session after sign-in, outlet switch and sign-out.
 */
export function OutletFeaturesSync() {
  useLocation();
  const context = getSelectedContext();
  const outletId = getStaffToken() && context?.kind !== "brand" ? (context?.outlet?.id ?? null) : null;
  useOutletFeatures(outletId);
  return null;
}
